import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { _t } from "../util/Translator";
import ReCAPTCHA from "react-google-recaptcha";
import * as AfeFields from "../components/AfeFields";
import * as Actions from "../actions";
import store from "../store";

const recaptchaRef = React.createRef();

class ContactForm extends Component {
  state = {
    isLoading: false,
    sendOk: false
  };

  componentDidMount() {
    //store.dispatch(getLastJobs());
  }

  onSubmit = async (formValues) => {
    try {
      this.setState({ isLoading: true });

      const recaptchaValue = recaptchaRef.current.getValue();

      console.log("recaptchaValue", recaptchaValue);

      if (recaptchaValue !== null && recaptchaValue !== "") {
        await store.dispatch(Actions.requestContact(formValues));
      } else {
        window.alert(`Are you a robot?`)
      }
      
      this.setState({ isLoading: false, sendOk: true });

      //this.props.history.push('/jobs/' + this.props.match.params.id + '/create-confirmed');

    } catch (error) {
      this.setState({ isLoading: false });

      const errorMessage = (error.response && error.response.data && error.response.data.error_description) ? 
        error.response.data.error_description : "Something went wrong!, " + error.message;
      
      throw new SubmissionError({ _error: errorMessage });
    } 
  }

  render() {
    const { handleSubmit, submitting, error } = this.props;

    if (this.state.sendOk) {
      return (
        <Fragment>
          <h3>{_t("contact.confirmationTitle")}</h3>
          <p>
            {_t("contact.confirmationText")}
          </p>
        </Fragment>
      );
    }

    return (
      <Fragment> 
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        <form onSubmit={handleSubmit(this.onSubmit)}>
          
          <div className="row">
            <div className="col-md-12 mb-2">
              <Field name="fullName" type="text" component={AfeFields.Input} placeholder={_t("contact.nombreCompleto")} />
              <Field name="email" type="text" component={AfeFields.Input} placeholder={_t("contact.correoElectronico")} />
              <Field name="phone" type="text" component={AfeFields.Input} placeholder={_t("contact.telefono")} />
              <Field name="message" type="text" component={AfeFields.Textarea} placeholder={_t("contact.mensaje")} rows={6}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 ml-4 mb-4">
              <Field name="agreeTheTermsOfService" type="checkbox" component={AfeFields.Checkbox}>
                {_t("home.contactAcceptTermsText")}&nbsp;
                <Link to="/home/politicaDePrivacidad">{_t("footer.privacyPolicy")}</Link>&nbsp;/&nbsp;
                <Link to="/home/terminosYCondiciones">{_t("footer.termsAndConditions")}</Link>&nbsp;/&nbsp;
                <Link to="/home/proteccionDeDatos">{_t("footer.dataProtection")}</Link>
              </Field>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mb-4">
              <ReCAPTCHA 
                ref={recaptchaRef}
                sitekey="6LdGfcwUAAAAAKA-dcK1A7m_q4MoVnPMVaNXDvg4"
                badge='inline'
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <button type="submit" className="btn btn-primary font-default-normal" 
                disabled={submitting || this.state.isLoading}>{_t("contact.enviar")}</button>
            </div>
          </div>
        </form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {}
  if (!values.fullName) {
    errors.name = _t("errors.required");
  } 
  if (!values.email) {
    errors.email = _t("errors.required");
  }
  if (!values.phone) {
    errors.phone = _t("errors.required");
  }
  if (!values.message) {
    errors.message = _t("errors.required");
  }
  if (!values.agreeTheTermsOfService) {
    errors.politicaDePrivacidad = _t("errors.youMustCheckPrivacyPolicy");
  }
  return errors;
}

const warn = values => {
  const warnings = {}
  return warnings;
}

const form = reduxForm({
  form: 'contactForm', // a unique identifier for this form
  validate, // <--- validation function given to redux-form
  warn // <--- warning function given to redux-form
})(ContactForm);

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {}, 
    enableReinitialize: true
  };
};

export default connect(
  mapStateToProps,
  {
    
  }
)(form);
